import { render, staticRenderFns } from "./hedefgerceklesmetablosu.vue?vue&type=template&id=272df4a0"
import script from "./hedefgerceklesmetablosu.vue?vue&type=script&lang=js"
export * from "./hedefgerceklesmetablosu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports